export const TOOL_TITLE =
  "Explore How School Choice and Boundary Policies Shape School Segregation";

//These two bind together to form the first white box on the left page, but the second is a pseudo-button.
export const INSTRUCTION_TEXT =
  "<b>To select a district, use the search bar or click a dot on the chart below.</b> Use the dropdown menu to explore school segregation by student race, ethnicity, or income level.";
export const GLOSSARY_POPOVER_TEXT = "View glossary of terms.";
export const GLOSSARY_POPOVER_HEADING = "GLOSSARY";

export const LEFT_CHART_TITLE =
  "Comparison of Boundary Policy Transparency and School Segregation in the 100 Largest School Districts";

export const LEFT_Y_AXIS_LABEL = "More transparent boundary policies";
export const LEFT_Y_AXIS_LABEL_INFO =
  "A maximum score of 5 indicates a district has information about its boundary processes online, weighs several factors during the process, offers multiple methods of community input, and has recently redrawn its boundaries.";
export const MAGNET_SCHOOLS_INFO =
  "Public schools that offer a special curriculum that emphasizes certain subjects, such as technology or the arts.";
export const SPECIALIZED_SCHOOLS_INFO = 
  "A type of public magnet school that tends to be highly selective and narrowly focused on a single subject.";
export const TRANSPORTATION_INFO_3 = 
  "District’s transportation to school choice policy is unknown.";

export const STATE_POLICIES_INFO =
  "Shows whether the state that a district is located in has policies that allow students to attend a public school outside their assigned district (interdistrict open enrollment) or to attend a different school within their assigned district (intradistrict open enrollment).";

export const STATE_POLICY_INTER_LOOKUP = {
  "1": { label: "Mandatory interdistrict open enrollment", yes: true },
  "2": { label: "Voluntary interdistrict open enrollment", yes: true },
  "3": { label: "Interdistrict open enrollment policy", yes: false },
  "4": { label: "Interdistrict policies; only one district", yes: false }
};

export const STATE_POLICY_INTRA_LOOKUP = {
  "1": { label: "Mandatory intradistrict open enrollment", yes: true },
  "2": { label: "Voluntary intradistrict open enrollment", yes: true },
  "3": { label: "Intradistrict open enrollment policy", yes: false }
};

export const RIGHT_DISTRICT_POLICIES_TITLE = "District and State Policies";
//this needs combined with [XX] = district name
  "A score of 3 or above means a district publishes information on how they draw boundaries, considers several factors when redrawing boundaries, and offers one or more opportunities for community input.";
export const LEFT_X_AXIS_LABEL = "More segregated";
export let LEFT_CHART_BOUNDARY_TOOLTIP_LABEL = "Boundary transparency score";

export const RIGHT_DISTRICT_INSTRUCTIONS =
  "Use the dropdowns to explore different segregation metrics and to categorize districts by student enrollment, region, or urbanicity.";
export const RIGHT_CHART_TITLE =
  "Explore School Segregation in Districts With and Without These School Choice Policies";

export const SEGREGATION_OPTIONS = [
  {
    label: "Segregation between white students and students of color",
    value: "NormalizedExpWhiteMinority"
  },
  { label: "Segregation between white and Black students", value: "NormalizedExpWhiteBlack" },
  { label: "Segregation between white and Hispanic students", value: "NormalizedExpWhiteHispanic" },
  {
    label: "Segregation between students with low incomes and others",
    value: "NormalizedExpFRLNonFRL"
  }
];

export const GROUPING_OPTIONS = [
  {
    label: "Number of students enrolled",
    value: "enrollment_size",
    breakdown: [
      { label: "<75k", value: 2 },
      { label: "75k–100k", value: 1 },
      { label: ">100k", value: 3 }
    ]
  },
  {
    label: "Region",
    value: "region",
    breakdown: [
      { label: "Central or Southern US", value: 1 },
      { label: "East or Northeastern US", value: 2 },
      { label: "Western US", value: 3 }
    ]
  },
  {
    label: "Urban versus suburban",
    value: "urbanicity",
    breakdown: [
      { label: "Urban", value: 1 },
      { label: "Suburban", value: 2 }
    ]
  }
];
